import {DashboardItem} from '../components/authority-dashboard/authority-dashboard.model';

export enum OperationTypes {
	QUOTATION_CREATED = 'QUOTATION_CREATED',
	QUOTATION_UPDATED = 'QUOTATION_UPDATED',
	QUOTATION_DELETED = 'QUOTATION_DELETED',
	WARRANTY_TYPE_SINGLE_ENTRY_UPDATED = 'WARRANTY_TYPE_SINGLE_ENTRY_UPDATED',
	WARRANTY_TYPE_MULTIPLE_ENTRIES_UPDATED = 'WARRANTY_TYPE_MULTIPLE_ENTRIES_UPDATED',
	WARRANTY_TYPE_ALL_ENTRIES_UPDATED = 'WARRANTY_TYPE_ALL_ENTRIES_UPDATED',
	DEALER_SINGLE_ENTRY_UPDATED = 'DEALER_SINGLE_ENTRY_UPDATED',
	DEALER_ALL_ENTRIES_UPDATED = 'DEALER_ALL_ENTRIES_UPDATED',
	UNKNOWN = 'UNKNOWN'
}

export enum WorkingTypes {
	MECHANIC = 'MECHANIC',
	CARBODY = 'CARBODY',
	GLASS = 'GLASS',
	ADMINISTRATION = 'ADMINISTRATION'
}

export enum PracticeAssociation {
	ADMINISTRATIVE_PRACTICES = 'ADMINISTRATIVE_PRACTICES'
}

export enum ClaimsAssociation {
	REQUIRED = 'REQUIRED',
	OPTIONAL = 'OPTIONAL',
	DENIED = 'DENIED'
}

export enum RepairsAssociation {
	REQUIRED = 'REQUIRED',
	OPTIONAL = 'OPTIONAL',
	DENIED = 'DENIED'
}

export enum PracticesAssociation {
	REQUIRED = 'REQUIRED',
	OPTIONAL = 'OPTIONAL',
	DENIED = 'DENIED'
}

export enum MaintenanceTypes {
	FULL_MAINTENANCE_STANDARD = 'FULL_MAINTENANCE_STANDARD',
	FULL_MAINTENANCE_PREMIUM = 'FULL_MAINTENANCE_PREMIUM',
	SERVICE_MAINTENANCE_STANDARD = 'SERVICE_MAINTENANCE_STANDARD',
	SERVICE_MAINTENANCE_PREMIUM = 'SERVICE_MAINTENANCE_PREMIUM'
}

export enum AdditionalServices {
	MECHANIC_PICK_UP = 'MECHANIC_PICK_UP',
	CARBODY_PICK_UP = 'CARBODY_PICK_UP',
	TYRE_PICK_UP = 'TYRE_PICK_UP',
	WASHING = 'WASHING'
}

export enum ReplacementVehicles {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
	F = 'F',
	G = 'G',
	H = 'H',
	J = 'J',
	L = 'L',
	N = 'N',
	R = 'R',
	S = 'S',
	T = 'T',
	W = 'W',
	Y = 'Y',
	Z = 'Z',
	K = 'K',
	V = 'V',
	I = 'I',
	Q = 'Q',
	U = 'U',
	M1 = 'M1'
}

export enum ReplacementVehicleDuration {
	MORE_THAN_2 = 'MORE_THAN_2',
	MORE_THAN_4 = 'MORE_THAN_4',
	MORE_THAN_8 = 'MORE_THAN_8',
	MORE_THAN_40 = 'MORE_THAN_40',
	MORE_THAN_0 = 'MORE_THAN_0'
}

// TODO
// è inutile e va tolta
// crea confusione in quanto unisce sia gli stati dell'intervento che della pratiac
export enum DossierAndWorkingStates {
	TO_ESTIMATE = 'TO_ESTIMATE',
	TO_SEND = 'TO_SEND',
	APPROVING = 'APPROVING',
	SUPERVISOR_APPROVING = 'SUPERVISOR_APPROVING',
	WAITING_FOR_WORKING = 'WAITING_FOR_WORKING',
	WAITING_PARTS = 'WAITING_PARTS',
	WORKING = 'WORKING',
	DELIVERING = 'DELIVERING',
	INVOICING = 'INVOICING',
	CLOSED = 'CLOSED',
	APPROVED = 'APPROVED',
	DECLINED = 'DECLINED',
	INTEGRATION_TO_SEND = 'INTEGRATION_TO_SEND',
	RE_APPROVING = 'RE_APPROVING',
	TO_CHANNEL = 'TO_CHANNEL',
	C_FLOW_APPROVING = 'C_FLOW_APPROVING',
	C_FLOW_REJECTED = 'C_FLOW_REJECTED',
	ADMINISTRATIVE_WORKING = 'ADMINISTRATIVE_WORKING',
	ADMINISTRATIVE_REJECTED = 'ADMINISTRATIVE_REJECTED',
	ADMINISTRATIVE_WAITING_FOR_CLOSED = 'ADMINISTRATIVE_WAITING_FOR_CLOSED',
	WORKING_TO_CHANNEL = 'WORKING_TO_CHANNEL',
	REJECTED_GROUP = 'REJECTED_GROUP',
	RE_DECLINED = 'RE_DECLINED',
	WITH_APPOINTMENT = 'WITH_APPOINTMENT',
	WITH_ACCEPTANCE = 'WITH_ACCEPTANCE',
	REJECTED = "REJECTED",

	/**
	 *  Stati finti - non esistono a BE
	 * 	quando selezionati devono esssere gestiti in questo modo:
	 * 
	 * 	- CLOSED_TO_BE_ARCHIVED va mandato a BE con
	 *     status=CLOSED & to_archive=true
	 * 
	 *  vale solo per la ricerca degli interventi attivi
	 * 
	 * 
	 *  Stato inserito con performance archiviazione
	 *  le pratiche chiuse hanno un periodo di retention
	 *  (30 giorni) in cui rimangono nel DB Attivo.
	 * 	Finito il periodo viene passata nel DB Archivio.
	 * 
	 *  18/03/2025 - gli stati finti non esistono più neanche a FE
	 * 
	 */ 
	// CLOSED_TO_BE_ARCHIVED = "CLOSED_TO_BE_ARCHIVED",
}

export enum EWorkingStates {
	TO_ESTIMATE 											= 'TO_ESTIMATE',
	TO_SEND 													= 'TO_SEND',
	PRE_AUTHORITY_REJECTED 						= 'PRE_AUTHORITY_REJECTED',
	TO_CHANNEL 												= 'TO_CHANNEL',
	APPROVING 												= 'APPROVING',
	DECLINED 													= 'DECLINED',
	REJECTED 													= 'REJECTED',
	WAITING_FOR_UNFREEZE 							= 'WAITING_FOR_UNFREEZE',
	WAITING_FOR_ACCEPTANCE 						= 'WAITING_FOR_ACCEPTANCE',
	SUPERVISOR_APPROVING 							= 'SUPERVISOR_APPROVING',
	SUPERVISOR_REJECTED 							= 'SUPERVISOR_REJECTED',
	WAITING_PARTS 										= 'WAITING_PARTS',
	RE_APPROVING 											= 'RE_APPROVING',
	RE_DECLINED 											= 'RE_DECLINED',
	C_FLOW_APPROVING 									= 'C_FLOW_APPROVING',
	C_FLOW_REJECTED 									= 'C_FLOW_REJECTED',
	WAITING_FOR_WORKING 							= 'WAITING_FOR_WORKING',
	ADMINISTRATIVE_WORKING 						= 'ADMINISTRATIVE_WORKING',
	WORKING 													= 'WORKING',
	INTEGRATION_TO_SEND 							= 'INTEGRATION_TO_SEND',
	CLOSED_WITH_LIQUIDATION 					= 'CLOSED_WITH_LIQUIDATION',
	CLOSED_WITH_REJECTION 						= 'CLOSED_WITH_REJECTION',
	ADMINISTRATIVE_WAITING_FOR_CLOSED = 'ADMINISTRATIVE_WAITING_FOR_CLOSED',
	ADMINISTRATIVE_REJECTED 					= 'ADMINISTRATIVE_REJECTED',
	CLOSED 														= 'CLOSED',
};

export enum DossierWorkingWoe {
	WRECK = 'WRECK',
	ONEROUS = 'ONEROUS',
	CONTRACT_EXPIRED = 'CONTRACT_EXPIRED'
}

export enum CarglassWorkingStates {
	TO_REJECT = 'TO_REJECT',
	REJECTED = 'REJECTED',
	AUTHORIZED = 'AUTHORIZED',
	TO_AUTHORIZE = 'TO_AUTHORIZE',
}

export enum PartsOrderStates {
	NEW = 'NEW',
	WORKING = 'WORKING',
	WITH_PARTS_TO_SEND = 'WITH_PARTS_TO_SEND',
	AUTHORITY_APPROVING = 'AUTHORITY_APPROVING',
	CLOSED = 'CLOSED',
	CANCELED = 'CANCELED',
	APPROVING = 'APPROVING',
	CANCELED_BY_REJECTION = 'CANCELED_BY_REJECTION'
}

export enum PartsActions {
	SEND_PARTS = 'SEND_PARTS'
}

// TODO
// da rinominare in EDossierFlowType
export enum DossierFlowType {
	ALD_POOL 												= 'ALD_POOL',
	CONSIP_FEE 											= 'CONSIP_FEE',
	CONSIP_OPEN_BOOK 								= 'CONSIP_OPEN_BOOK',
	SECOND_LIFE_WITH_RESTORATION 		= 'SECOND_LIFE_WITH_RESTORATION',
	SECOND_LIFE_WITHOUT_RESTORATION = 'SECOND_LIFE_WITHOUT_RESTORATION',
	POPGO 													= 'POPGO',
	EXPIRED 												= 'EXPIRED',
	REMARKETING 										= 'REMARKETING',
	STANDARD 												= 'STANDARD',
	REPAIR	  											= 'ALD_REPAIR'
}

export enum PartTypes {
	UNKNOWN = 'UNKNOWN',
}

export enum PartsType {
	KIT = 'KIT',
}

export enum WorkingActions {
	// Operazioni Comuni
	MODIFY_QUOTATION = 'MODIFY_QUOTATION',
	EDIT_WARRANTY_TYPE = 'EDIT_WARRANTY_TYPE',
	SEND_ALERT = 'SEND_ALERT',
	DOWNLOAD_QUOTATION_PDF = 'DOWNLOAD_QUOTATION_PDF',
	PREVIEW_QUOTATION_PDF = 'PREVIEW_QUOTATION_PDF',

	//Operazioni op. Centro
	SEND_QUOTATION = 'SEND_QUOTATION',
	START_WORKING = 'START_WORKING',
	FINISH_WORKING = 'FINISH_WORKING',
	DELETE_QUOTATION = 'DELETE_QUOTATION',
	INTEGRATE_QUOTATION = 'INTEGRATE_QUOTATION',
	ARRIVED = 'ARRIVED',

	//Operazioni comuni Ald e supervisor
	APPROVE = 'APPROVE',
	DECLINE = 'DECLINE',
	RE_APPROVE = 'RE_APPROVE',
	RE_DECLINE = 'RE_DECLINE',
	DEALER_MANY_PARTS = 'DEALER_MANY_PARTS',
	SEND_ADMINISTRATION_PRACTICE = 'SEND_ADMINISTRATION_PRACTICE',
	SEND_TO_CONSIP = 'SEND_TO_CONSIP',
	EXTRA_TOTAL_CONSIP = 'EXTRA_TOTAL_CONSIP',
	CONSIP_APPROVE  = 'CONSIP_APPROVE',
	CONSIP_REJECT  = 'CONSIP_REJECT',
	REMOVE_EXTRA_TOTAL_CONSIP = 'REMOVE_EXTRA_TOTAL_CONSIP',
	BILL_WITHOUT_LAST_INTEGRATION = 'BILL_WITHOUT_LAST_INTEGRATION',
	REJECT = 'REJECT',

	//Operazioni op. supervisor
	SUPER_APPROVE = 'SUPER_APPROVE',
	SUPER_REJECT = 'SUPER_REJECT',
	SUPER_DECLINE = 'SUPER_DECLINE',
	CANCEL_SUPER_REJECT = 'SUPER_CANCELED',
	SENT_TO_SUPERVISOR = 'SENT_TO_SUPERVISOR',
	DOWNLOAD_PDF = 'DOWNLOAD_PDF',
	FORCE_CHANNELING = 'FORCE_CHANNELING',

	//Operazioni Authority Supervisor e Ald Operator
	FORCE_QUOTATION_REFRESH = 'FORCE_QUOTATION_REFRESH'
}

export enum AuthorityDashboardActions {
	APPOINTMENT,
	CARBODY,
	MECHANIC,
	ADMINISTRATION,
	HIGH_PRIORITY,
	DOSSIER_TO_ESTIMATE,
	DOSSIER_WORKING,
	DOSSIER_DELIVERING,
	DOSSIER_CLOSED,
	DOSSIER_WORKING_APPROVING,
	WAITING_PARTS,
	WAITING_FOR_WORKING,
	WITH_PARTS_TO_SEND,
	CANCELLED,
	WORKING,
	APPROVING,
	CLOSED,
	CARGLASS_TO_AUTHORIZE,
	CARGLASS_TO_REJECT,
	CARGLASS_AUTHORIZED,
	CARGLASS_REJECTED,
	NEW,
	AUTHORITY_APPROVING,
	APPROVED,
	TO_CHANNEL,
	WOE_WRECK,
	WOE_ONEROUS,
	WOE_EXPIRED,
	HIGH_PRIORITY_SUPERVISOR,
	ADMINISTRATIVE_DOSSIER_WORKING,
	ADMINISTRATIVE_WAITING_FOR_CLOSED,
	ADMINISTRATIVE_CLOSED,
	CANCELED_BY_REJECTION,
	REJECTED_GROUP,
	WITH_APPOINTMENT,
	WITH_ACCEPTANCE,
}

export enum EDossierWorkingDashboardStatus {
	WITH_INTEGRATION = 'WITH_INTEGRATION',
	CLOSED           = 'CLOSED',
	REJECTED_GROUP   = 'REJECTED_GROUP',
	APPROVED         = 'APPROVED',
	APPROVING        = 'APPROVING',
	WAITING_PARTS    = 'WAITING_PARTS',
}

export enum PartStates {
	NEW = 'NEW',
	AVAILABLE = 'AVAILABLE',
	ORDERED = 'ORDERED',
	NOT_COMPLIANT = 'NOT_COMPLIANT',
	UNAVAILABLE = 'UNAVAILABLE',
	REMOVED = 'REMOVED'
}


export enum ProfileType {
	ALD = 'ALD',
	ASSISTANCE_CENTER = 'CENTER',
	SUPERVISOR = 'SUPERVISOR',
	DEALER = 'OP'
}

export interface FileModel {
	uuid?: string;
	file_manager_id?: string;
	file_name?: string;
	blob_name?: string;
	file_size?: number;
	blob_type?: string;
	mime_type?: string;
	description?: string;
	created_at?: any;
	file_manager_name?: string;
	file_content?: any;
	hidden?: boolean;
	validate?: boolean;
	blob_url?: string;
	thumbnail_id?: string;
	user?: string;
	user_name?: string;
	blob_size?: number;
	resource_type?: string;
}

export enum QuotationTableFields {
	CHECKBOX = 'CHECKBOX',
	BRAND = 'BRAND',
	PART_NUMBER = 'PART_NUMBER',
	AMOUNT = 'AMOUNT',
	WARRANTY = 'WARRANTY',
	DESCRIPTION = 'DESCRIPTION',
	NEW = 'NEW',
	HOUR = 'HOUR',
	PART_COST = 'PART_COST',
	DISCOUNT = 'DISCOUNT',
	EXTRA_DISCOUNT = 'EXTRA_DISCOUNT',
	PART_VALUE = 'PART_VALUE',
	INVOICING = 'INVOICING',
	STATUS = 'STATUS',
	DEALER = 'DEALER'
}

export enum CasualType {
	ORDINARY_MAINTENANCE = 'ORDINARY_MAINTENANCE',
	DAMAGE_MECHANICAL = 'DAMAGE_MECHANICAL',
	// GLASS = 'GLASS',
	BODY_WARRANTY = 'BODY_WARRANTY',
	DAMAGE_REPAIR = 'DAMAGE_REPAIR',
	DAMAGE_DURING_ASSISTANCE = 'DAMAGE_DURING_ASSISTANCE',
	TRANSPORT_DAMAGE = 'TRANSPORT_DAMAGE',
	MECHANICAL_WARRANTY = 'MECHANICAL_WARRANTY',
	EXTRAORDINARY_MAINTENANCE = 'EXTRAORDINARY_MAINTENANCE',
	ADMINISTRATIVE_PRACTICES = 'ADMINISTRATIVE_PRACTICES',
	WARRANTY_SERVICE = 'WARRANTY_SERVICE',
	RECALL = 'RECALL',
	REPAIR = 'REPAIR',
	REMARKETING = 'REMARKETING',
}

export abstract class BaseAuthorityDashboardItems {
	static findDashboardItemCounter(dashboardItems: DashboardItem[], status: string): string {
		const dashboardItem: DashboardItem =  dashboardItems && dashboardItems.find(item => item.label === status);
		return !!dashboardItem ? dashboardItem.count : '0';
	}
}

export enum VehicleType {
	BIKE = 'BIKE',
	CAR = 'CAR',
	SUV = 'SUV',
	VAN = 'VAN',
	AUTOCARRO = 'AUTOCARRO'
}

export enum ReRegistrationPlateStatus {
	DETERIORATED = 'DETERIORATED',
	LOST = 'LOST',
	STOLEN = 'STOLEN',
}

export enum RePunchingProcessingAt {
	SAME_CENTER = 'SAME_CENTER',
	OTHER_CENTER = 'OTHER_CENTER',
}

export enum AuthorityAppointmentModelStatus {
	NEW = 'NEW',
	PLANNING = 'PLANNING',
	PLANNED = 'PLANNED',
	PENDING = 'PENDING',
	CLOSED = 'CLOSED',
	EXPIRED = 'EXPIRED',
	PLANNING_HIDDEN = 'PLANNING_HIDDEN',
}

export enum ProcessingTypes {
	TO_RE_REGISTER = 'TO_RE_REGISTER', //DA REINMATRICOLARE
	STAMP = 'STAMP', // RIPUNZONATURA
}

export enum NoteReferenceType {
	AUTHORITY_DOSSIER = 'AUTHORITY_DOSSIER',
	AUTHORITY_WORKING = 'AUTHORITY_WORKING',
	AUTHORITY_ENTRY_PART = 'AUTHORITY_ENTRY_PART'
}

export const dossierSearchRegex: RegExp = /^NE[0-9]+$/;
export const workingSearchRegex: RegExp = /^NE[ACGM][0-9]+$/;
export const glassSearchRegex: RegExp = /^NEG[0-9]+$/;

export enum ClaimSourceType {
	N = 'N',
	W = 'W',
	D = 'D'
}
